import { useRouter } from 'next/router'

import {
  TagManager,
  getCreateMapLink,
  getEditMapLink,
  getSearchQuery
} from 'utils'
import { MAPS_LIMIT } from '~workspace/constants/maps'
import useDeleteMapById from '~workspace/hooks/useDeleteMapById'
import { useMaps, useMapsLoading, useMapsTotal } from '~workspace/states/maps'
import { useHref } from '~workspace/states/ui'
import { useIsWorkspaceMember, useWorkspace } from '~workspace/states/workspace'
import View from './view'

/**
 * @IMPORTANT
 * The link is added to mapstack.io production
 */
export const SAMPLE_MAP_URL =
  'https://mapstack-prod-public-resources.s3.amazonaws.com/sample-data/us-counties.geojson'

const MapList = () => {
  const href = useHref()
  const router = useRouter()
  const { page = 1, query, tags, workspaceId, workspaceName } = router.query

  const maps = useMaps()
  const total = useMapsTotal()
  const loading = useMapsLoading()
  const { deleteMapById, deleting } = useDeleteMapById()
  const isWorkspaceMember = useIsWorkspaceMember()
  const workspace = useWorkspace()

  const pagination = {
    page,
    total,
    limit: MAPS_LIMIT
  }

  const handlePageChange = (event, page) => {
    router.push({ query: { ...router.query, page: page } })
  }

  const handleCreateMapClick = () => {
    if (!isWorkspaceMember) return

    router.push(
      getCreateMapLink({
        workspaceId: workspace.id,
        workspaceName: workspace.name
      })
    )
  }

  const handleEditMapClick = (mapId) => {
    if (!isWorkspaceMember || !mapId || !workspaceId || !workspaceName) return

    router.push(getEditMapLink({ workspaceId, workspaceName, mapId }))
  }

  const handleDeleteMapConfirm = async (mapId) => {
    TagManager.dataLayer.deleteMap()
    deleteMapById(mapId)
  }

  const createTagHref = (tag) => {
    return getSearchQuery(
      {
        sort: 'all',
        tags: [tag.id]
      },
      href
    )
  }

  const isSearching = query?.length || !!tags?.length
  const noResultsText = isSearching && 'No maps found'

  return (
    <View
      noResultsText={noResultsText}
      loading={loading}
      isDeletingMap={deleting}
      defaultMapUrl={SAMPLE_MAP_URL}
      canCreateMap={isWorkspaceMember}
      canDeleteMap={isWorkspaceMember}
      maps={maps}
      tagHref={createTagHref}
      pagination={pagination}
      onPageChange={handlePageChange}
      onCreateMapClick={handleCreateMapClick}
      onEditMapClick={handleEditMapClick}
      onDeleteMapConfirm={handleDeleteMapConfirm}
    />
  )
}

export { MapList }
export default MapList
